module.exports = "/_next/static/images/Channel@2x-09b54b3ddb23ca1a6b83406ab4c7777d.png";